import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern Living kit — a vending machine, 0.9 x 0.8 x 1.9 m: dark body, a big
// front glass panel (+Z) with shelf strips visible behind it, a coin panel and
// pickup flap on the right of the front, one muted red accent band on top.
const MATTE_BLACK = "#2e2e30";
const DARK_GLASS = "#3a3f44";
const STEEL = "#aab2b8";
const WARM_WHITE = "#efece6";
const ACCENT_RED = "#a8524a";

export const vendingMachine = defineModel({
  id: "vending-machine",
  batchId: "modern",
  name: "Vending Machine",
  tags: ["modern", "interior", "appliance", "restaurant", "retail", "vending"],
  summary: "A dark vending machine with a glass front, shelf strips and a coin panel.",
  tiles: { w: 1, h: 1 },
  footprint: 1.1,
  parts(): Part[] {
    return [
      // body
      { geometry: new THREE.BoxGeometry(0.9, 1.9, 0.78), color: MATTE_BLACK, position: [0, 0.95, -0.01] },
      // muted red accent band across the top front
      { geometry: new THREE.BoxGeometry(0.9, 0.16, 0.02), color: ACCENT_RED, position: [0, 1.78, 0.385] },
      // shelf strips reading through the glass (goods rows, just proud of the pane)
      { geometry: new THREE.BoxGeometry(0.5, 0.05, 0.02), color: WARM_WHITE, position: [-0.13, 0.72, 0.394] },
      { geometry: new THREE.BoxGeometry(0.5, 0.05, 0.02), color: WARM_WHITE, position: [-0.13, 1.02, 0.394] },
      { geometry: new THREE.BoxGeometry(0.5, 0.05, 0.02), color: WARM_WHITE, position: [-0.13, 1.32, 0.394] },
      { geometry: new THREE.BoxGeometry(0.5, 0.05, 0.02), color: WARM_WHITE, position: [-0.13, 1.58, 0.394] },
      // big front glass panel over the shelves
      { geometry: new THREE.BoxGeometry(0.58, 1.24, 0.015), color: DARK_GLASS, position: [-0.13, 1.08, 0.392] },
      // coin panel on the right of the front
      { geometry: new THREE.BoxGeometry(0.2, 0.5, 0.02), color: STEEL, position: [0.32, 1.25, 0.39] },
      // coin slot
      { geometry: new THREE.BoxGeometry(0.03, 0.1, 0.01), color: MATTE_BLACK, position: [0.32, 1.38, 0.402] },
      // pickup flap low on the right
      { geometry: new THREE.BoxGeometry(0.24, 0.2, 0.02), color: DARK_GLASS, position: [0.28, 0.32, 0.39] },
      // plinth
      { geometry: new THREE.BoxGeometry(0.82, 0.1, 0.7), color: DARK_GLASS, position: [0, 0.05, -0.01] },
    ];
  },
  animations: [],
});
